import React from 'react';
import Swal from "sweetalert2";

//import { useTranslation } from "react-i18next";

import {
    Row, Col
} from "reactstrap";
import CGridstack from 'components/CGridstack';

export default function GroupFrag(props) {
    const { data, modelFctManager, parentProps, isConfiguration, childShouldRerender, parentDisabled } = props;//bindPropResult

    //const { t } = useTranslation();
    //const altT = (label, args) => { return (label && label.startsWith("i18n:")) ? t(label.replace("i18n:", ""), args) : label };

    const [shouldRender, setShouldRender] = React.useState(false);

    React.useEffect(() => {
        if (data.onActionEvents && data.onActionEvents["onLoad"]) {
            data.onActionEvents["onLoad"].forEach((args, index) => {
                modelFctManager.onActionRequired(data.name, args, data).then(actionResponse => {
                    //console.debug("RESPONSE");
                    //console.debug(actionResponse);
                    if (actionResponse && !actionResponse.isSuccess && (!Swal.isVisible() || actionResponse.forceMessage)) {
                        Swal.fire({
                            icon: "error",
                            title: "Echec",
                            html: actionResponse.errorMessage
                        });
                    }
                });
            });
        }

        if ((!data.items || data.items.length === 0) && modelFctManager?.finalizeProcess) modelFctManager.finalizeProcess(data, parentProps);
    }, []);

    //useEffect sur props pour trigger APRES le render du composant
    React.useEffect(() => {
        data.childRendered = 0;
        if (childShouldRerender && modelFctManager?.commonRenderProc) modelFctManager.commonRenderProc(data);
    }, [props]);
    if (!childShouldRerender && modelFctManager?.commonRenderProc) modelFctManager.commonRenderProc(data);

    data.functionManager = {};
    data.functionManager.getChilds = () => { return data.items; };
    data.functionManager.getParentProps = () => { return parentProps; };
    data.functionManager.rerender = (forceChild) => {
        setShouldRender(!shouldRender);
        if (forceChild) {
            data.items.forEach((child) => {
                child?.functionManager?.rerender(true);
            });
        }
    };
    data.functionManager.getParent = () => {
        return parentProps.parentData;
    };

    var childs = [];
    if (data.items) {
        /*if (bindPropResult === "contacts") {//TEMP TEST
            data.defaultValue = [{ name: "TEST1", firstName: "test" }, { name: "TEST2", firstName: "test" }, { name: "TEST3", firstName: "test3" }];
        }*/
        if (Array.isArray(data.defaultValue)) {
            if (data.isModel && data.clonable && !data.isLoaded) {
                data.defaultValue.forEach((srcElem) => {
                    var cloneElem = JSON.parse(JSON.stringify(data));
                    cloneElem.key = null;
                    cloneElem.isModel = false;
                    cloneElem.clonable = false;
                    cloneElem.hidden = false;
                    cloneElem.temporary = true;//echo à isCloned mais défini si l'élément doit être supprimé au chargement
                    cloneElem.bindPropResult = null;
                    cloneElem.isInfluencedBy = data.bindPropResult;

                    //TODO : gérer un loadedData en param de modelFctManager.componentTyped (srcElem)

                    //INFO : la modification du data du parent va causer un rerender qui va afficher les clones
                    parentProps.childs.push(cloneElem);//TODO : voir pour ajotuer les éléments juste après le modele
                });
                data.isLoaded = true;
            }
        }

        data.items = data.items.filter(child => !child.isCloned);
        childs = data.items.map((child) => {
            var childRender = modelFctManager.componentTyped(child, { parentData: data, childs: data.items, parentDisabled: (parentDisabled || data.disabled ? true : false) });

            if (isConfiguration && !child.gridWidth) {
                var design = child.mergedDesign || child.customDesign?.design;
                var wSize = 0.2;
                if (design) {
                    wSize = design.boxSize || 0.2;
                    child.gridWidth = Math.round(parseFloat(wSize) * 12);
                }
            }
            return childRender;
        });
    }

    modelFctManager.applyChildsClone(data, childs, parentDisabled);

    data.childCount = childs.length;

    var frameClass = "";
    var groupClass = "align-items-center";
    var groupStyle = { marginLeft: "auto", marginRight: "auto" };
    if (data.hidden) {
        if (isConfiguration) {
            frameClass += " config-hidden";
        }
        else {
            frameClass += " d-none";
        }
    }
    if (data.checkRights) {
        var hasRights = modelFctManager.checkRights(data.checkRights.entity, data.checkRights.rights);
        if (!hasRights) frameClass += " d-none";
    }

    var design = data.customDesign?.design;
    design = modelFctManager.prepareMergedDesign(data, design, "default_group");
    data.mergedDesign = design;
    if (design) {
        if (design.boxSize) {
            frameClass += modelFctManager.manageBoxSize("group-" + parentProps?.parentData?.gridID + "-" + data?.key, design.boxSize, data);
        }

        Object.assign(groupStyle, modelFctManager.setCustomBackground(design, data));
        Object.assign(groupStyle, modelFctManager.managePadding(design, groupClass));
        Object.assign(groupStyle, modelFctManager.manageMargin(design, groupClass));

        if (design.width) {
            if (parseFloat(design.width.replace("px", "")) >= 0) groupStyle.width = design.width;
            else {
                groupClass += " w-100";
            }
            groupStyle.overflowX = "hidden";//auto
            //frameClass += " m-0";
        }
        if (design.maxWidth) groupStyle.maxWidth = design.maxWidth;
        if (design.height) {
            if (parseFloat(design.height.replace("px", "")) >= 0) groupStyle.height = design.height;
            else {
                frameClass += " h-100";
                groupClass += " h-100";
            }
            groupStyle.overflowY = "hidden";//auto
            //frameClass += " m-0";
        }

        switch (parseInt(design.spacing)) {
            case 1: groupClass += " gx-1"; break;
            case 2: groupClass += " gx-2"; break;
            case 3: groupClass += " gx-3"; break;
            case 4: groupClass += " gx-4"; break;
            case 5: groupClass += " gx-5"; break;
            default:
                if (design.spacing > 5) groupClass += " gx-5";
                break;
        }
        switch (design.alignment) {
            case "end":
            case "right":
                //frameStyle.direction = "rtl";
                groupClass += " justify-content-end";
                break;
            case "center":
                groupClass += " justify-content-center";
                break;
            default:
                break;
        }
    }

    //TODO : designInput


    if (data.subType === "floating") {
        frameClass += " floating-group";
    }

    if (isConfiguration && !data.gridID) data.gridID = Math.floor(Math.random() * 1000000000);

    var nextPos = 0;//TODO : x/y A GERER : pas toujours en vertical...
    var prevHeight = 0;//TODO : x/y A GERER : pas toujours en vertical...

    //return <Col data-name="GroupFrag" data-element={data.objType} xs="auto" className={`${frameClass} p-0`}><Row className={`${groupClass} m-0`} style={groupStyle}>{childs}</Row></Col>;
    return isConfiguration ? <div data-name="GroupFrag" data-element={data.objType} className={`${frameClass} ${groupClass} p-0`} style={groupStyle} data-backimage={groupStyle.hasImage || null} data-imageopacity={groupStyle.alpha || null}>
        <CGridstack data={childs.map((child, index) => {
            var width = 2;
            var item;
            if (data.items) {
                item = data.items[index];

                if (item?.objType === "picture") width = 5;

                if (item && item.gridWidth) width = item.gridWidth;
            }

            if (nextPos + width > 12) {//autoPosition ???
                nextPos = 0;
                prevHeight += 2;//TODO : Doit dépendre de la height de l'autre composant ???...
            }
            var gridItem = { children: child, id: "item-" + data.gridID + "-" + (item?.key || index), srcData: item, noCard: true, x: nextPos, y: prevHeight, w: width/*, h: 1*/, sizeToContent: true };//autoPosition ???
            nextPos = (nextPos + width);
            return gridItem;
        })} type={"group"} srcData={data} configModel={null} isConfigurationMode={true} withRemove={true} noOneColumn={true} defaultState={true} className="" target={`grid-stack-group-${data.gridID}`} gridClass={"grid-stack-nested"} actionsClass={"text-secondary"} gridOpts={{ cellHeight: 50, sizeToContent: true, acceptWidgets: ".grid-item, .grid-itemsContainer, .grid-stack-group > .grid-stack-item", column: data.customDesign?.design?.boxSize === "1" ? 12 : "auto" }} triggerClick={(grid, dataItem) => { modelFctManager.setSelected(grid, dataItem); }}
            onDropped={(event, prevNode, n) => {
                modelFctManager.dropManager(data, event, prevNode, n);
                setShouldRender(!shouldRender);
            }} />
    </div>
        : <Col data-name="GroupFrag" data-element={data.objType} xs="auto" className={`${frameClass} p-0`}><Row className={`${groupClass}`} style={groupStyle} data-backimage={groupStyle.hasImage || null} data-imageopacity={groupStyle.alpha || null}>{childs}</Row></Col>;

}